import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FailedRequest } from "../../services/api/types/offline/models/FailedRequest";

interface FailedRequestsState {
  requests: FailedRequest[];
}

const initialState: FailedRequestsState = {
  requests: [],
};

export const failedRequestsSlice = createSlice({
  name: "failedRequests",
  initialState,
  reducers: {
    addFailedRequest: (state, action: PayloadAction<FailedRequest>) => {
      state.requests.push(action.payload);
    },
    clearFailedRequests: (state) => {
      state.requests = [];
    },
  },
});

export const { addFailedRequest, clearFailedRequests } =
  failedRequestsSlice.actions;
export const selectFailedRequests = (state: {
  failedRequests: FailedRequestsState;
}) => state.failedRequests.requests;
export default failedRequestsSlice.reducer;
